import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import SelectSearch from 'react-select-search';
import {makeSelectSelectedModel} from './selectors';
import {FlexSection} from '../UIKit';
import {selectModel} from './actions';

class Model extends React.Component {
  constructor(props) {
    super(props);
  }

  selectModel = (value, item) => {
    if (value && item) {
      this.props.modelSelected(value, item.name, item.endProductionYear);
    }
  };

  renderModel(props, option, snapshot, className) {
    return (
      <button {...props} className={className} type="button">
        <span>
          <span>{option.name}</span>
        </span>
      </button>
    );
  }

  render() {
    const {isLoading, title, placeholder, models, selected} = this.props;
    return (
      <div id="CarSelectorBrand" className={isLoading ? 'is-loading' : null}>
        <FlexSection
          title={title}
          children={
            <SelectSearch
              name="model-brand"
              className="select-search-box select-search-box--multiple"
              value={selected}
              onChange={this.selectModel}
              options={models}
              placeholder={placeholder}
              renderOption={this.renderModel}
              disabled={isLoading || models.length < 1}
              search
            />
          }
        />
      </div>
    );
  }
}

Model.defaultProps = {
  models: [],
  placeholder: 'Seleziona',
  errors: {},
  isLoading: true,
};
Model.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.string,
  placeholder: PropTypes.string,
  models: PropTypes.array,
  errors: PropTypes.object,
  modelSelected: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  selected: makeSelectSelectedModel(),
});

export function mapDispatchToProps(dispatch) {
  return {
    modelSelected: (model, modelName, modelYear) =>
      dispatch(selectModel(model, modelName, modelYear)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Model);
